import { createComponent } from '@carvana/merch-components';

export const Container = createComponent('div', {
  className: `
    mt-8
    flex
    h-56
    flex-row
    rounded
    border
    border-grey-2
    bg-white
    font-sans
    first-of-type:mt-0
  `
});

export const Input = createComponent('input', {
  className: `
    peer
    relative
    w-[271px]
    overflow-visible
    border-none
    pl-16
    pt-20
    text-base
    leading-5
    text-blue-6
    placeholder-transparent
    outline-none
  `
});

export const Label = createComponent('label', {
  className: `
    absolute
    left-16
    top-[2px]
    z-0
    mb-8
    block
    origin-top-left
    translate-x-0
    translate-y-[11px]
    scale-[0.86]
    transform
    p-0
    text-[13px]
    font-bold
    uppercase
    leading-3
    text-grey-5
    transition
    delay-0
    duration-200
    ease-out
    peer-placeholder-shown:translate-x-0
    peer-placeholder-shown:translate-y-[19px]
    peer-placeholder-shown:scale-100
    peer-focus:translate-x-0
    peer-focus:translate-y-[11px]
    peer-focus:scale-[0.86]
  `
});

export const IconContainer = createComponent('div', {
  className: 'pr-8 pt-8'
});
